import { Component, OnInit, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { OpAdminCheckoutService } from "../../services/op-admin-checkout.service";

@Component({
  selector: "app-order-edit-dialog",
  templateUrl: "./order-edit-dialog.component.html",
  styleUrls: ["./order-edit-dialog.component.css"],
})
export class OrderEditDialogComponent implements OnInit {
  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  codeList: any = [];
  orderEditForm: FormGroup;
  email: any;
  constructor(
    private activeModal: NgbActiveModal,
    private checkoutSrv: OpAdminCheckoutService
  ) {}

  ngOnInit() {
    this.getCountryList();
    this.buildCheckOutForm();
  }

  buildCheckOutForm() {
    this.orderEditForm = new FormGroup({
      id: new FormControl(null, Validators.required),
      shipping_firstname: new FormControl(null, Validators.required),
      shipping_lastname: new FormControl(null, Validators.required),
      shipping_country: new FormControl(null, Validators.required),
      shipping_city: new FormControl(null, Validators.required),
      shipping_postcode: new FormControl(null, Validators.required),
      shipping_address: new FormControl(null, Validators.required),
    });
    this.patchCheckOutForm(this.message);
  }

  patchCheckOutForm(orderData) {
    this.orderEditForm.patchValue({
      id: orderData.orderId,
      shipping_firstname: orderData.shipping_firstname,
      shipping_lastname: orderData.shipping_lastname,
      shipping_country: orderData.shipping_country,
      shipping_city: orderData.shipping_city,
      shipping_postcode: orderData.shipping_postcode,
      shipping_address: orderData.shipping_address,
    });
  }

  getCountryList() {
    this.checkoutSrv.getCodeList().subscribe((res: any) => {
      this.codeList = res.data;
    });
  }

  selectShippingCountry(event) {
    this.orderEditForm.patchValue({
      shipping_country: event.target.value,
    });
  }

  public decline() {
    this.activeModal.close(false);
  }

  public accept() {}

  public dismiss() {
    this.activeModal.dismiss();
  }

  OrderUpdate(formValues) {
    this.checkoutSrv.updateOrderDetails(formValues).subscribe(
      (res: any) => {
        this.activeModal.close(true);
      },
      (error) => {
        console.error(error);
        this.activeModal.dismiss();
      }
    );
  }
}
